import React from 'react';

import Headline from '../../common/Headline';
import OrderOfEvents from '../../order-of-events/OrderOfEvents';
import { eventsData } from '../../order-of-events/orderOfEventsData';

const RegistrationInfo = () => {
    return (
        <div className="bg-white">
            <Headline
                headline="How to join the Collabothon 2023!"
                classNames="text-primary2 pt-20"
            />
            <div className="w-full px-6 xl:px-0 xl:w-3/4 3xl:w-1/2 5xl:w-1/3 mx-auto pb-20">
                <OrderOfEvents data={eventsData} />
            </div>
        </div>
    );
};

export default RegistrationInfo;
